"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = _interopRequireDefault(require("./index.scss"));

var _image = _interopRequireWildcard(require("../../tools/cloudinary/image"));

var Image = function Image(_ref) {
  var className = _ref.className,
      imageUrl = _ref.imageUrl,
      ratio = _ref.ratio,
      alt = _ref.alt,
      bgSize = _ref.bgSize,
      type = _ref.type;

  if (!imageUrl) {
    return _react["default"].createElement("div", {
      className: className
    }, _react["default"].createElement("div", {
      className: (0, _classnames["default"])(_index["default"].placeholder, _index["default"][ratio])
    }));
  }

  return _react["default"].createElement("img", {
    className: className,
    src: (0, _image["default"])({
      src: imageUrl,
      ratio: ratio,
      numberofItems: 1,
      bgSize: bgSize,
      type: type
    }),
    alt: alt
  });
};

Image.defaultProps = {
  alt: ''
};
Image.propTypes = {
  className: _propTypes["default"].string,
  imageUrl: _propTypes["default"].string,
  ratio: _propTypes["default"].oneOf(_image.ratioOptions),
  alt: _propTypes["default"].string,
  bgSize: _propTypes["default"].oneOf(['cover', 'contain']),
  type: _propTypes["default"].oneOf(['mobile'])
};
var _default = Image;
exports["default"] = _default;